import { Button, Text } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useOrganizationsSearch } from '../../../../../../contexts/organizationsSearchContext'
import { useNavigation } from '../../../../contexts/navigationContext'
import { DropDownHeaderAccessor } from '../../enums/dropDownHeaderAccessor'
import { OrganizationItem } from '../../types/organizationItem'
import { DropdownHeaderItem } from './elements/DropdownHeaderItem'
import * as Styled from './styles'

interface DropdownHeaderProps {
  organizationsItems: OrganizationItem[]
  selectedId?: string
}

export const DropdownHeader = ({ organizationsItems, selectedId }: DropdownHeaderProps) => {
  const { t } = useTranslation()
  const { isInverted, setShouldCloseDropdown } = useNavigation()
  const { setIsOpen } = useOrganizationsSearch()

  const topThreeOrganizations = organizationsItems.slice(0, 3)
  const organizationGroup = topThreeOrganizations.filter(
    (item) => item.accessorGroupId === DropDownHeaderAccessor.Organization,
  )
  const umbrellaGroup = topThreeOrganizations.filter((item) => item.accessorGroupId === DropDownHeaderAccessor.Umbrella)
  const moreThanThreeOrganizations = organizationsItems.length > 3

  const textColor = isInverted ? 'inverted' : 'secondary'

  const renderGroup = useCallback(
    (items: OrganizationItem[], titleKey: string) => {
      if (items.length === 0) {
        return null
      }

      return (
        <>
          <Styled.AccessorListItem isInverted={isInverted}>
            <Text variant="bodySM" colorVariant={textColor}>
              {t(titleKey)}
            </Text>
          </Styled.AccessorListItem>
          {items.map((item) => (
            <DropdownHeaderItem key={item.id} organization={item} selectedId={selectedId} />
          ))}
        </>
      )
    },
    [isInverted, selectedId, t, textColor],
  )

  return (
    <Styled.DropdownHeaderWrapper isInverted={isInverted}>
      <ul>
        {renderGroup(umbrellaGroup, 'organization_search.header.advisor_accounts')}
        {renderGroup(organizationGroup, 'organization_search.header.organizations')}
      </ul>
      {moreThanThreeOrganizations && (
        <Button
          variant={isInverted ? 'textOnColor' : 'text'}
          fullWidth
          color="primary"
          onClick={() => {
            setShouldCloseDropdown(true)
            setIsOpen(true)
          }}
          data-testid="see-all-organizations"
        >
          {t('navigation.dropdown.button.label.see_all_organizations')}
        </Button>
      )}
    </Styled.DropdownHeaderWrapper>
  )
}
